import { repositoryFetch } from 'shared/repositories/repositoryFetch';

export const axilTagValuesByTagIdEndpoint = '/v1/axil/config/tag_values/by_tag_id';
export const fetchTagById = (accessToken, body) => repositoryFetch({
  accessToken,
  body,
  endpoint: axilTagValuesByTagIdEndpoint,
});
